// extracted by mini-css-extract-plugin
export default {"wrapper":"WarningModal_wrapper__nBwCG","text":"WarningModal_text__GsnXE","iconWrapper":"WarningModal_iconWrapper__mOeie"};